/**
 * 权限查看Modal配置
 * 用于查看服务权限的树形配置
 */

// 权限查看弹窗基础配置
export const PERMISSION_MODAL_CONFIG = {
  title: "权限查看",
  width: 600,
  height: "auto",
  contentPadding: {
    vertical: 16,
    horizontal: 0,
  },
} as const;

// 权限查看弹窗尺寸配置
export const permissionViewModalSize = {
  width: PERMISSION_MODAL_CONFIG.width,
  height: PERMISSION_MODAL_CONFIG.height,
  maxWidth: "95vw",
  minWidth: PERMISSION_MODAL_CONFIG.width,
} as const;

// 权限查看弹窗搜索配置
export const permissionViewSearchConfig = {
  enabled: true,
  placeholder: "搜索权限名称、编码...",
} as const;

// 权限查看弹窗选择配置（禁用选择功能，仅查看）
export const permissionViewSelectionConfig = {
  enabled: false,
} as const;

// 权限查看弹窗树形配置
export const permissionViewTreeConfig = {
  defaultExpandAll: true,
  loading: false,
} as const;

// 权限查看弹窗 Modal 属性配置
export const permissionViewModalProps = {
  destroyOnClose: true,
} as const;

// 权限查看弹窗操作按钮配置
export const permissionViewActionConfig = {
  closeText: "关闭",
} as const;

// 操作名称映射 - 将权限操作代码映射为中文显示名称
export const actionNameMap: Record<string, string> = {
  view: "查看",
  create: "创建",
  update: "更新",
  delete: "删除",
  assign: "分配",
  revoke: "撤销",
  assign_role: "分配角色",
  import: "导入",
  export: "导出",
  "*": "全部权限",
};

